<template>
  <v-card class="mx-auto" width="90%" style="margin-bottom: 15px;">
    <v-container fluid class="my-5">
      <v-layout row justify-center>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="countries"
              sort-by="name"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>{{ $t('views.adminCountries.title') }}</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ $t('views.adminCountries.importExport') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('views.adminCountries.importExport') }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea v-model="countriesJSON" :rules="rules.json" outlined :label="$t('views.adminCountries.countriesConfig')" auto-grow rows="5" />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="gray"
                          text
                          @click="close"
                        >
                          {{ $t('views.adminCountries.close') }}
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="save"
                          :disabled="!validJson"
                        >
                          {{ $t('views.adminCountries.save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.weekly_minimum_spend="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip v-on="on" v-bind="attrs">
                      {{ $t('views.adminCountries.json') }}
                    </v-chip>
                  </template>
                  <span>{{ item.weekly_minimum_spend }}</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                {{ $t('views.adminCountries.noData') }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import numbro from 'numbro'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      countriesJSON: [],
      dialog: false
    }
  },
  methods: {
    ...mapActions('settings', [
      /* 'loadCountries', */
      'saveCountries'
    ]),
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.countriesJSON = JSON.stringify(this.countries)
      })
    },
    save () {
      // Save this.countriesJSON to Firebase
      this.saveCountries({
        countries: this.countriesJSON
      })
      this.close()
    },
    formatMinSpend (item) {
      return item.toString()
    }
  },
  computed: {
    ...mapGetters('settings', [
      'countries'
    ]),
    headers () {
      return [
        { text: this.$t('views.adminCountries.headerName'), value: 'name' },
        {
          text: this.$t('views.adminCountries.headerIsoCode'),
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: this.$t('views.adminCountries.headerTrpCost'), value: 'trp_cost' },
        { text: this.$t('views.adminCountries.headerWeeklyMinSpend'), value: 'weekly_minimum_spend' }
      ]
    },
    rules () {
      return {
        json: [
          v => !!v || this.$t('views.adminCountries.validationJsonRequired'),
          v => !v || this.validJson || this.$t('views.adminCountries.validationInvalidJson'),
          v => !v || this.validCountries || this.$t('views.adminCountries.validationInvalidCountries')
        ]
      }
    },
    validJson () {
      try {
        return (JSON.parse(this.countriesJSON) && !!this.countriesJSON)
      } catch (e) {
        return false
      }
    },
    validCountries () {
      try {
        const json = JSON.parse(this.countriesJSON)
        for (const country of json) {
          if (
            country.id && country.id.length === 2 &&
            country.name && country.name.length > 2 &&
            country.trp_cost && !isNaN(country.trp_cost) &&
            country.weekly_minimum_spend && typeof country.weekly_minimum_spend === 'object' && !Array.isArray(country.weekly_minimum_spend) &&
            Object.keys(country.weekly_minimum_spend).length > 0
          ) {
            // Not invalid JSON structure yet
          } else {
            // Invalid JSON structure
            return false
          }
        }
        // Valid JSON structure
        return true
      } catch (e) {
        return false
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    countries (val) {
      this.countriesJSON = JSON.stringify(val)
    }
  }
}
</script>
